import { yupResolver } from '@hookform/resolvers/yup';
import { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from '../../../Utils/Common';

const ModalCaptionFoto = ({ onCallback, image, show, close }) => {

    const [isLoading, setLoading] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {
        if (show && image) {
            reset({ caption: image.caption || '' });
        }
    }, [show, image]);

    const validationSchema = Yup.object().shape({
        caption: Yup.string().nullable(),
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        if (!image || !image.id) return;

        setLoading(true);

        fetch(getEndpointUrl() + `/v2/inspector/caption/${image.id}`, {
            method: "PUT",
            body: new URLSearchParams({
                caption: data.caption || ''
            }),
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {
                toast.success("Yay, Caption berhasil disimpan.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                if (typeof onCallback === 'function') {
                    onCallback(json.results?.data);
                }

                close();
            } else {
                toast.error(json.message || 'Gagal menyimpan caption.', {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan..." : "Tulis Caption Foto"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                {image && (
                                    <div className="mb-3 text-center">
                                        <img
                                            src={getEndpointUrl() + image.file_path}
                                            alt={image.original_filename}
                                            className="img-fluid rounded"
                                            style={{ maxHeight: '200px', objectFit: 'contain' }}
                                        />
                                    </div>
                                )}
                                <Form.Group className="mb-3" controlId="formCaption">
                                    <Form.Label>Caption</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Tulis caption untuk foto ini..."
                                        {...register("caption")}
                                        isInvalid={errors.caption ? true : false}
                                        autoComplete="off"
                                    />
                                    <Form.Text className="text-black-50 fst-italic">
                                        Caption akan ditampilkan sebagai keterangan pada foto hasil inspeksi.
                                    </Form.Text>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="primary" type="submit">Simpan Caption</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(ModalCaptionFoto);
